import React from "react";
import "../Techbody/Techbody.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import htmlimg from "../Assets/html.png";
import cssimg from "../Assets/css.png";
import jsimg from "../Assets/javascript.png";
import reactimg from "../Assets/react.png";
import angimg from "../Assets/angular.png";
import vueimg from "../Assets/vuejs.png";

const Uitypes = () => {
  return (
    <section>
      <div className="text-center">
        <h2 className="py-4">Frontend Technologies</h2>

        <Container>
          <Row className="justify-content-center gx-4">
            <Col sm={8} md={4} className="mb-3 ">
              <div className="border border-2  bg-white techbody-col">
                <img src={htmlimg} alt="" />
                <h4>HTML</h4>
                <p className="text-content ">
                  HTML stands for HyperText Markup Language. It is the most
                  basic building block of the Web. It defines the meaning and
                  structure of web content using special elements called tags.
                  HTML uses tags to annotate text, images, links, and other
                  content for display in a Web browser. HTML also allows you to
                  use other technologies such as CSS and JavaScript to enhance
                  the appearance and functionality of your web pages. The
                  current standard is HTML5
                </p>
              </div>
            </Col>
            <Col sm={8} md={4} className=" mb-3">
              <div className="border border-2 bg-white techbody-col">
                <img src={cssimg} alt="" />
                <h4>CSS</h4>
                <p className="text-content ">
                  CSS stands for Cascading Style Sheets. It is a style sheet
                  language that is used to specify the presentation and styling
                  of a document written in a markup language such as HTML or
                  XML. CSS allows you to apply different styles to HTML
                  elements, such as colors, fonts, layouts, animations, and
                  more. CSS can also be used to create responsive web design,
                  which adapts to different screen sizes and devices.CSS works
                  by using selectors to target HTML elements and applying
                  declarations
                </p>
              </div>
            </Col>
            <Col sm={8} md={4} className="mb-3 ">
              <div className="border border-2 bg-white techbody-col">
                <img src={jsimg} alt="" />
                <h4>Javascript</h4>
                <p className="text-content ">
                  JavaScript is a scripting or programming language that allows
                  you to create dynamic and interactive web pages. It can run on
                  both the browser and the server, and it supports multiple
                  paradigms such as imperative, declarative, and object-oriented
                  programming. JavaScript has a lightweight, interpreted, and
                  single-threaded nature, and it can work with other web
                  technologies such as HTML and CSS. JavaScript has a standard
                  library of built-in objects, such as Array, Date, String ect.
                </p>
              </div>
            </Col>
          </Row>
          <Row gutter={20} className="justify-content-center gx-4">
            <Col sm={8} md={4} className="mb-3">
              <div className="border border-2 bg-white techbody-col">
                <img src={angimg} alt="" />
                <h4>Angular</h4>
                <p className="text-content ">
                  Angular is a TypeScript-based web application framework that
                  supports full-stack development for building all types of web
                  applications. It has a component-based architecture that
                  allows you to create reusable and modular UI elements. It also
                  provides a collection of well-integrated libraries that cover
                  various features, such as routing, forms, testing, and more.
                  Angular is open-source and maintained by Google and a large
                  community of developers.
                </p>
              </div>
            </Col>
            <Col sm={8} md={4} className="mb-3 ">
              <div className="border border-2 bg-white techbody-col">
                <img src={reactimg} alt="" />
                <h4>React</h4>
                <p className="text-content ">
                  React is a JavaScript library for creating user interfaces. It
                  lets you build web pages using components, which are reusable
                  pieces of code that can display data, handle events, and
                  interact with other components. React uses a special syntax
                  called JSX, which allows you to write HTML-like code in
                  JavaScript. React also uses a virtual DOM, which is a fast and
                  efficient way of updating the browser without reloading the
                  page. React is open-source and maintained by Facebook.
                </p>
              </div>
            </Col>
            <Col sm={8} md={4} className="mb-3 ">
              <div className="border border-2 bg-white techbody-col">
                <img src={vueimg} alt="" />
                <h4>VueJs</h4>
                <p className="text-content ">
                  Vue.js is a JavaScript framework for building user interfaces.
                  It extends standard HTML with a template syntax that allows
                  you to declaratively describe HTML output based on JavaScript
                  state. It also has a reactive system that automatically
                  updates the DOM when the state changes. Vue.js has a
                  component-based architecture that lets you create reusable and
                  modular UI elements. Vue.js is open-source and maintained by a
                  large community of developers.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  );
};

export default Uitypes;
